export default [
    // **********************************************************************
    // UNIFICAR PACIENTES (Patient Identity Merge, S-9B)
    // La visibilidad por rol es sólo UX: la autorización la decide la API
    // (patient_identity_merge.execute) en cada pedido.
    // **********************************************************************
    {
        name: 'patient-identity-merge',
        path: 'patient-merge',
        component: () => import('@/components/patient-identity-merge/IndexPage'),
        meta: {
            title: 'Unificar pacientes',
            auth: {
                roles: 'admin'
            }
        }
    }
]
